import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { CookieConsent } from './components/CookieConsent';
import { Home } from './pages/Home';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfUse } from './pages/TermsOfUse';
import { AccessibilityStatement } from './pages/AccessibilityStatement';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="2rlf7wxar9w4y">
      <BrowserRouter data-id="element-1" data-mp="2rit3v7n2pyrh">
        <Routes data-id="element-2" data-mp="2mm2mmgzj8x4h">
          <Route path="/" element={<Home data-id="element-4" data-mp="2mn5ash5h0lgp" />} data-id="element-3" data-mp="2mmcbg18ucy8l" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-6" data-mp="31agp2qt1ejki" />} data-id="element-5" data-mp="2mnnge4e0wc1a" />
          <Route path="/terms-of-use" element={<TermsOfUse data-id="element-8" data-mp="31ctflscv2296" />} data-id="element-7" data-mp="31brzh9gzmpkl" />
          <Route path="/accessibility" element={<AccessibilityStatement data-id="element-10" data-mp="2wj8dpp85co4p" />} data-id="element-9" data-mp="2wk9zooqpav17" />
          <Route path="*" element={<Home data-id="element-12" data-mp="28u5uwe1s0p8m" />} data-id="element-11" data-mp="2wi5nljineppu" />
        </Routes>
        <CookieConsent data-id="element-13" data-mp="28t4k8aooa4rf" />
      </BrowserRouter>
    </LanguageProvider>;
}